import { bussinessTheme } from "@boseo/shared/themes";

const theme = {
    ...bussinessTheme,
};

export default theme;
